import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Search, ChevronRight } from 'lucide-react';

const Header = ({ title, subtitle, action }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleProfileClick = () => {
    navigate('/my-profile');
  };

  return (
    <header className="bg-white border-b border-slate-200 px-8 py-4" data-testid="header">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-2xl font-semibold text-slate-900 tracking-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-slate-500 mt-1">{subtitle}</p>
          )}
        </div>

        <div className="flex items-center gap-4">
          {/* Action Buttons */}
          {action && (
            <div className="flex items-center gap-2">
              {action}
            </div>
          )}
          
          {/* Search */}
          <div className="relative hidden md:block">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <input
              type="text"
              placeholder="Search..."
              data-testid="header-search"
              className="w-64 pl-10 pr-4 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:bg-white transition-all duration-200"
            />
          </div>

          {/* User Avatar - Clickable */}
          <button 
            onClick={handleProfileClick}
            className="flex items-center gap-3 pl-4 border-l border-slate-200 hover:bg-slate-50 -ml-2 px-3 py-1.5 rounded-lg transition-colors group"
            data-testid="user-profile-btn"
          >
            <div className="w-9 h-9 rounded-full bg-slate-900 flex items-center justify-center">
              <span className="text-sm font-medium text-white">
                {user?.name?.charAt(0).toUpperCase()}
              </span>
            </div>
            <div className="hidden md:block text-left">
              <p className="text-sm font-medium text-slate-900">{user?.name}</p>
              <p className="text-xs text-slate-500 capitalize">{user?.role}</p>
            </div>
            <ChevronRight className="w-4 h-4 text-slate-400 hidden md:block group-hover:text-slate-600 transition-colors" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
